import type { Address } from '@billx/types';

/**
 * Format address as short or long string
 * - short: street, city
 * - long: street, city, state, zipcode, country
 */
export const getAddressString = (
  address: Partial<Address> | undefined,
  form: 'short' | 'long' = 'long'
): string => {
  if (!address) return '';
  const parts =
    form === 'short'
      ? [address.street, address.city]
      : [
          address.street,
          address.city,
          address.state,
          address.zipcode,
          address.country,
        ];
  return parts.filter((p) => p && p.trim() !== '').join(', ');
};
